export default "__VITE_ASSET___app/immutable/assets/default-avatar-6.BriTMAbh.svg__"